export function getSubdomain() {
  const hostname = window.location.hostname

  // mysite.ru или www.mysite.ru → без поддомена
  if (hostname === "pro100quiz.ru" || hostname === "www.pro100quiz.ru") {
    return ""
  }

  const parts = hostname.split(".")

  // balashiha.pro100quiz.ru → ["balashiha", "pro100quiz", "ru"]
  if (parts.length < 3) {
    return ""
  }

  return parts[0]
}